import { render } from "./productChannelRiavlList.vue?vue&type=template&id=7e039992&scoped=true"
import script from "./productChannelRiavlList.vue?vue&type=script&lang=js"
export * from "./productChannelRiavlList.vue?vue&type=script&lang=js"

import "./productChannelRiavlList.vue?vue&type=style&index=0&id=7e039992&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e039992"],['__file',"src/views/marketing/productChannelRiavlList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e039992"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e039992', __exports__)) {
    api.reload('7e039992', __exports__)
  }
  
  module.hot.accept("./productChannelRiavlList.vue?vue&type=template&id=7e039992&scoped=true", () => {
    api.rerender('7e039992', render)
  })

}


export default __exports__